export const ADD_PRODUCT = 'addProduct';
export const ADD_SINGLE_PRODUCT = 'addSingleProduct';
export const ADD_NEW_PRODUCT = 'addNewProduct';
export const BULK_PRODUCT_UPLOAD = 'bulkProductUpload';
export const ADD_CATALOG_PRODUCT = 'addCatalogProduct';